import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import { initAnalytics } from "@/lib/analytics";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

const sentryDsn =
  import.meta.env.VITE_SENTRY_DSN ||
  "https://736f06fa45a828fea40a971143a4ed9b@o4509727471763456.ingest.de.sentry.io/4511055267037264";
const environment = import.meta.env.MODE;
const isProduction = import.meta.env.PROD;

const tracesSampleRate = isProduction ? 0.2 : 1;
const replaysSessionSampleRate = isProduction ? 0.05 : 0;
const replaysOnErrorSampleRate = 1;
const shouldLoadReplay = isProduction;

const scheduleReplayIntegration = () => {
  const loadReplayIntegration = () => {
    Sentry.addIntegration(Sentry.replayIntegration());
  };

  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(loadReplayIntegration, { timeout: 5000 });
    return;
  }

  window.setTimeout(loadReplayIntegration, 3000);
};

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment,
    sendDefaultPii: true,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    tracesSampleRate,
    replaysSessionSampleRate,
    replaysOnErrorSampleRate,
  });

  if (shouldLoadReplay) {
    scheduleReplayIntegration();
  }
}

initAnalytics();
